(function ($) {
  jQuery(document).ready(function () {
    // Team member
    document.querySelectorAll('.team-members-slider').forEach(function(slider) {
      new Swiper(slider, {
        navigation: {
          nextEl: ".team-members-slider-button-next",
          prevEl: ".team-members-slider-button-prev",
        },
        slidesPerView: "auto",
        spaceBetween: 19,
        breakpoints: {
          0: {
            spaceBetween: 18,
          },
          992: {
            spaceBetween: 19,
          },
        },
      });
    });
    // End Team member

    // Timeline slider
    document.querySelectorAll('.timeline-content').forEach(function(slider) {
      new Swiper(slider, {
        navigation: {
          nextEl: ".timeline-slider-button-next",
          prevEl: ".timeline-slider-button-prev",
        },
        pagination: {
          el: '.timeline-pagination',
          clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '"></span>';
          }
        },
        slidesPerView: "auto",
        spaceBetween: 18,
      });
    });
    // End Timeline slider

    // Header active item
    $('.site-nav__dropdown-link').each(function () {
      if ( $(this).hasClass('site-nav__current') ) {
        $(this).parents('.site-nav__details').find('summary.site-nav__link').addClass('site-nav__current');
      }
    });

    // Variable
    function kinkindVariable() {
      var header_height = $(".site-header").outerHeight();
      var heightToolbar = $('.shopify-section-group-header-group.toolbar-section').outerHeight();
      $("body").css("--heightHeader", header_height + "px");
      $("body").css('--heightToolbar', heightToolbar + 'px');
      $("body").css('--heightScreen', `${window.innerHeight}px`)
    }
    kinkindVariable();
    $(window).on('resize', function(){
      kinkindVariable();
      featureProductsImageHeight();
    });
    $(window).scroll(function() {
      kinkindVariable();
      featureProductsImageHeight();
      // Header Fixed
      var scroll = $(window).scrollTop();
      if($('.shopify-section-group-header-group.toolbar-section').length>0) {
        var heightToolbar = $('.shopify-section-group-header-group.toolbar-section').outerHeight();
        if (scroll <= heightToolbar) {
          heightToolbar = heightToolbar - scroll;
          $("body").css('--heightToolbar', heightToolbar + 'px');
        } else {
          $("body").css('--heightToolbar', '0px');
        }
      }
    });

    // Footer mobile
    $('.footer__block--menu .footer__title').click(function() {
      $(this).parents('.footer__block--menu').toggleClass('active');
      $(this).next('ul').slideToggle();
    });

    // Home Trending Product Slider
    if($('.trending-product-slider').length>0) {
      var products_per_row = $('.trending-product-slider').attr('data-products_per_row');
      var swiper = new Swiper(".trending-product-slider", {
        // navigation: {
        //   nextEl: ".featured-collection-button-next",
        //   prevEl: ".featured-collection-button-prev",
        // },
        breakpoints: {
          0: {
            slidesPerView: 3,
            spaceBetween: 15,
            loop: true,
          },
          767: {
            slidesPerView: 3,
            spaceBetween: 15,
            loop: true,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 15,
            loop: false,
          },
          949: {
            slidesPerView: 3,
            spaceBetween: 15,
          },
          950: {
            slidesPerView: 4,
            spaceBetween: 15,
          },
          1199: {
            slidesPerView: 4,
            spaceBetween: 15,
          },
          1200: {
            slidesPerView: products_per_row,
            spaceBetween: 15,
          },
        },
      });
    }

    // Featured Collections Slider
    if($('.featured-collections-slider').length>0) {
      var swiper = new Swiper(".featured-collections-slider", {
        navigation: {
          nextEl: ".featured-collections-button-next",
          prevEl: ".featured-collections-button-prev",
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 15,
          },
          767: {
            slidesPerView: 1,
            spaceBetween: 15,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          949: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          950: {
            slidesPerView: 3,
            spaceBetween: 15,
          },
          1199: {
            slidesPerView: 3,
            spaceBetween: 15,
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 15,
          },
        },
      });
    }

    // Featured Products Slider
    if($('.featured-products-slider').length>0) {
      var swiper = new Swiper(".featured-products-slider", {
        navigation: {
          nextEl: ".featured-products-button-next",
          prevEl: ".featured-products-button-prev",
        },
        slidesPerView: 1
      });
    }
    function featureProductsImageHeight() {
      if($('.featured-products-slider').length>0) {
        var featuredImageHeight = $('.featured-products .grid-product__image-wrap').outerHeight();
        $(".featured-products").css('--featuredImageHeight', featuredImageHeight + 'px');
      }
    }

    // Height element
    function adjustElementHeights() {
      var elements = $('.section-beer-blub-block .items .item .content');
      var maxHeight = 0;
      elements.height('auto');
      elements.each(function() {
        var elementHeight = $(this).outerHeight();
        if(elementHeight > maxHeight) {
          maxHeight = elementHeight;
        }
      });
      elements.height(maxHeight);
    }
    adjustElementHeights();
    $(window).resize(function() {
      adjustElementHeights();
    });

    EmojiTextifier.start();
  });

  const EmojiTextifier = {
    emojiRegex: /\p{Emoji}(?!\uFE0E)/gu,
    observer  : null,

    processTextNode: function ( node ) {
      const original = node.nodeValue;
      const replaced = original.replace(this.emojiRegex, match => match + '\uFE0E');
      if ( original !== replaced ) {
        node.nodeValue = replaced;
      }
    },

    traverse: function ( node ) {
      if ( node.nodeType === Node.TEXT_NODE ) {
        this.processTextNode(node);
      }
      else if (
        node.nodeType === Node.ELEMENT_NODE &&
        node.nodeName !== 'SCRIPT' &&
        node.nodeName !== 'STYLE'
      ) {
        for ( const child of node.childNodes ) {
          this.traverse(child);
        }
      }
    },

    observe: function () {
      this.observer = new MutationObserver(mutations => {
        for ( const mutation of mutations ) {
          if ( mutation.type === 'characterData' ) {
            this.processTextNode(mutation.target);
          }
          for ( const node of mutation.addedNodes ) {
            if ( node.nodeType === Node.TEXT_NODE ) {
              this.processTextNode(node);
            }
            else if ( node.nodeType === Node.ELEMENT_NODE ) {
              this.traverse(node);
            }
          }
        }
      });

      this.observer.observe(document.body, {
        childList    : true,
        subtree      : true,
        characterData: true
      });
    },

    start: function () {
      this.traverse(document.body);
    },

    init: function () {
      this.traverse(document.body);
      this.observe();
    },

    stop: function () {
      if ( this.observer ) {
        this.observer.disconnect();
        this.observer = null;
      }
    }
  };
  EmojiTextifier.init();

  setTimeout(function () {
    EmojiTextifier.start();
  }, 1234);

})(jQuery);
